import React from 'react';

const DEFAULT_GRADING_SCALE = [
  { grade: 'A+', range: '90 - 100%' },
  { grade: 'A', range: '80 - 89%' },
  { grade: 'B+', range: '70 - 79%' },
  { grade: 'B', range: '60 - 69%' },
  { grade: 'C', range: '50 - 59%' },
  { grade: 'D', range: '35 - 49%' },
  { grade: 'F', range: 'Below 35%' }
];

const GradingScale = ({ gradingScale = [], primaryColor = '#1e3a8a' }) => {
  const scale = (gradingScale && gradingScale.length > 0) ? gradingScale : DEFAULT_GRADING_SCALE;

  return (
    <div style={{ marginBottom: '16px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '8px 12px' }}>
      <h5 style={{ margin: '0 0 6px 0', fontSize: '10px', fontWeight: '700', color: primaryColor, textTransform: 'uppercase' }}>
        📐 Institution Grading Scale Reference
      </h5>
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${Math.min(scale.length, 7)}, 1fr)`, gap: '6px', fontSize: '9.5px' }}>
        {scale.map((item, idx) => (
          <div key={idx} style={{ padding: '3px 6px', background: '#fff', border: '1px solid #cbd5e1', borderRadius: '4px', textAlign: 'center' }}>
            <span style={{ fontWeight: '700', color: '#0f172a' }}>{item.grade}</span>: <span style={{ color: '#475569' }}>{item.range}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GradingScale;
